var swiper = new Swiper(".kopstorm_topbar_1", {
  navigation: {
    prevEl: ".swiper-button-prev_slider",
    nextEl: ".swiper-button-next_slider",
  },
  loop: true,
  watchSlidesProgress: true,
  autoHeight: true,
  fadeEffect: { crossFade: true },
  autoplay: { enabled: true },
  effect: "fade",
  slidesPerGroupAuto: false,
});
